const app = {};

let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);

app.parsePrice = price => parseInt((price).replace(/[.,\s]/g, ''));

const formatMoneyWithoutTrailingZeros = price => {
    const precision = price % 100 === 0 ? 0 : 2;
    const number = (price / 100).toFixed(precision);
    const [dollars, cents] = number.split('.');
    const formattedDollars = dollars.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    return cents ? `${formattedDollars},${cents}` : formattedDollars;
};

const formatSwedishPrice = cents => {
    const hasCents = cents % 100 !== 0;

    return (cents / 100).toLocaleString('sv-SE', {
        style: 'currency',
        currency: 'SEK',
        minimumFractionDigits: hasCents ? 2 : 0,
        maximumFractionDigits: hasCents ? 2 : 0
    });
};

const stripHtml = string => {
    const element = document.createElement('div');
    element.innerHTML = string;
    return element.textContent;
};

app.currency = price => {
    if (document.documentElement.dataset.country === 'SE') {
        return formatSwedishPrice(price);
    }

    const language = document.documentElement.lang;
    const activeCurrency = window.Shopify.currency.active;
    const moneyFormat = stripHtml(document.documentElement.dataset.moneyFormat || '{{amount}}');
    const match = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);

    if (!match) {
        return moneyFormat;
    }

    const formattedPrice = moneyFormat.replace(match[0], formatMoneyWithoutTrailingZeros(price));

    if ((language === 'de' || language === 'fr' || language === 'es' || language === 'it' || language === 'pt') && activeCurrency === 'EUR') {
        return `${formattedPrice.replace('€', '').trim()}\u00a0€`;
    }

    return formattedPrice;
};

app.image = (url, w = null, h = null) => `${url}${w ? `&width=${w}` : ''}${h ? `&height=${h}` : ''}`;

app.lockBody = (keepScrollbar = true) => {
    if (document.body.classList.contains('locked')) {
        return;
    }

    const scrollTop = window.scrollY;

    document.body.classList.add('locked');

    if (scrollTop === 0) {
        document.body.classList.add('locked--on-top');
    }

    if (keepScrollbar && document.documentElement.scrollHeight > document.documentElement.clientHeight) {
        document.body.style.overflowY = 'scroll';
    }

    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.body.style.setProperty('margin-top', `-${scrollTop}px`, 'important');

    document.body.dataset.scrollTop = scrollTop;
};

app.unlockBody = () => {
    const hasOpenOverlay = [...document.querySelectorAll('[data-open]')].some((element) => (
        window.getComputedStyle(element).position === 'fixed'
    ));

    if (hasOpenOverlay) {
        return;
    }

    document.body.style.removeProperty('position');
    document.body.style.removeProperty('width');
    document.body.style.removeProperty('overflow-y');
    document.body.style.removeProperty('margin-top');

    window.scrollTo({ top: +document.body.dataset.scrollTop });

    document.body.classList.remove('locked', 'locked--on-top');
    document.body.removeAttribute('data-scroll-top');
};

app.viewport = {
    sizes: ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'],
    is: () => window.getComputedStyle(document.body, ':after').content.replace(/"/g, ''),
    isEqualOrGreaterThan: size => app.viewport.getIndex(app.viewport.is()) >= app.viewport.getIndex(size),
    isSmallerThan: size => app.viewport.getIndex(app.viewport.is()) < app.viewport.getIndex(size),
    getIndex: size => {
        const number = app.viewport.sizes.indexOf(size);
        if (number === -1) throw 'no valid viewport name given';
        return number;
    }
};

app.translationHelper = (key, variables) => {
    if(typeof TRANSLATIONS !== 'undefined' && typeof TRANSLATIONS[key] !== 'undefined') {
        let translation = TRANSLATIONS[key];

        if(typeof variables === 'object') {
            for(const variable in variables) {
                translation = translation.replace(variable, variables[variable]);
            }
        }

        return translation;
    }

    return key;
};

export default app;
